import { extend } from '@thd-nucleus/data-sources';

import { PromotionCardUdsDataModel } from './PromotionCardUdsDataModel';

export const PromotionCardDataModel = extend(
  PromotionCardUdsDataModel
);
